var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

var BottomBanners = function () {
	$aside = $( document.querySelectorAll( '#bottom-banners aside' ) );
};

/**
 * Equalize bottom banner height
 */
BottomBanners.prototype.init = function () {

	var self = this,
		maxH = 0,
		asideH;

	$aside.each( function () {
		asideH = $( this ).outerHeight();

		if ( asideH > maxH ) {
			maxH = asideH;
		}
	} );

	$aside.height( maxH );
};

module.exports = new BottomBanners();
